export default __webpack_public_path__ + "static/media/eric-berman.4ac6db72.jpg";